export default {
    data() {
        return {
            url: this.$serverURL + this.$api.cms.dealsSpecialCmsURL,
            cmsData: {},
            preview: {
                imageOne: "",
                imageTwo: "",
                imageThree: "",
                imageFour: "",
            }
        }
    },
    async created() {
        document.title = "Dispo - Deals Special CMS";
        this.getData();

    },
    methods: {
        async getData() {
            let response = await this.getCmsData(this.url);
            if (response.statusCode == 200) {
                this.cmsData = (response.data.length > 0) ? response.data[0] : {};
            }
            else {
                this.cmsData = {};
            }
        },
        handleUploadImage(imageKey, previewImageKey, ref, event) {
            this.cmsData[imageKey] = event.target.files[0];
            let input = this.$refs[ref];
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.preview[previewImageKey] = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        async updateCms() {
            try {
                let fromData = new FormData();
                fromData.append('bannerOneImage', this.cmsData.bannerOneImage);
                fromData.append('bannerOneLink', this.cmsData.bannerOneLink);
                fromData.append('bannerTwoImage', this.cmsData.bannerTwoImage);
                fromData.append('bannerTwoLink', this.cmsData.bannerTwoLink);
                fromData.append('bannerThreeImage', this.cmsData.bannerThreeImage);
                fromData.append('bannerThreeLink', this.cmsData.bannerThreeLink);
                fromData.append('bannerThreeMobileImage', this.cmsData.bannerThreeMobileImage);
                fromData.append('bannerThreeMobileLink', this.cmsData.bannerThreeMobileLink);
                fromData.append('productSliderOneTitle', this.cmsData.productSliderOneTitle);
                fromData.append('productSliderTwoTitle', this.cmsData.productSliderTwoTitle);
                this.$swal.showLoading();
                let response = await this.createUpdateCMS(this.url, fromData);
                if (response.statusCode == 200 || response.statusCode == 201) {
                    this.$refs.ref1.value = null;
                    this.$refs.ref2.value = null;
                    this.$refs.ref3.value = null;
                    this.$refs.ref4.value = null;
                    this.preview = {
                        imageOne: "",
                        imageTwo: "",
                        imageThree: "",
                        imageFour: "",
                    }
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
                await this.getData();
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            } finally {
                this.$swal.hideLoading();
            }
        }
    }
}